<div class="main-content">
    <div class="container mainContentNew" style="height: 80vh">
        <div class="row my-5">
            <div class="col-12 col-sm-12 col-md-12">
                <div class="d-flex justify-content-between p-2" style="border-bottom: 1px solid #ccc;">
                    <div class="d-flex">
                        <mat-icon  class="chat-back-button" (click)="goBack()" style="margin-right: 10px;">arrow_back</mat-icon>
                        <h4 class="text-black">Cyber Combine: Scorecard</h4>
                    </div>

                    <ul class="breadcrumb d-none d-sm-none d-lg-flex d-md-none">
                        <li class="active"><a style="color: #000;" [routerLink]="['/dashboard/home']">Dashboard</a></li>
                        <li class="separator">/</li>
                        <li><a style="color: #000" [routerLink]="['/my-wallet']" [queryParams]="{tab: 'scorecard'}">My Wallet</a></li>
                        <li class="separator">/</li>
                        <li><a style="color: #979797" href="#">Cyber Combine: Scorecard</a></li>
                    </ul>
                </div>

            </div>
        </div>
        <form [formGroup]="form">
            <div class="row my-5" style="border-bottom: 1px solid #DCDCDC">
                <div class="col-6 col-sm-6 col-md-6 col-lg-4 mt-3">
                    <b class="d-block mb-3 text-black">User Name</b>
                    <span class="text-grey">{{user?.fullName}}</span>
                </div>
                <div class="col-6 col-sm-6 col-md-6 col-lg-4 mt-3">
                    <b class="d-block mb-3 text-black">Date</b>
                    <span class="text-grey">{{assessment?.assessmentDate | date:'MM/dd/y'}}</span>
                </div>
                <div class="col-6 col-sm-6 col-md-6 col-lg-4 mt-3 pb-4">
                    <b class="d-block mb-3 text-black">Competition Level</b>
                    <span class="text-grey">{{assessment?.competitionLevel}}</span>
                </div>
            </div>
            <mat-card class="card-wrapper-bordered">
                <mat-card-content class="rounded-4" style="background: #F9F9F9">
                    <h5 class="my-3 text-black">Individual Challenge Scorecard</h5>
                    <div class="table-wrapper-bordered d-none d-sm-none d-md-none d-lg-block">
                        <table *ngIf="scorecards.length > 0" class="table table-borderless table-rounded">
                            <thead>
                            <tr>
                                <th>Challenge Name</th>
                                <th>Accuracy (%)</th>
                                <th>Competency (%)</th>
                                <th>Rank Level</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let s of scorecards; let i = index">
                                <td>
                                    <span class="d-block p-2 text-black">{{s.challengeName}}</span>
                                </td>
                                <td>
                                    <span class="d-block p-2 text-black">{{s.accuracy}}</span>
                                </td>
                                <td>
                                    <span class="d-block p-2 text-black">{{s.competency}}</span>
                                </td>
                                <td>
                                    <span class="d-block p-2 text-black">{{s.rankLevel}}</span>
                                </td>
                            </tr>
                            </tbody>

                        </table>
                    </div>
                    <div class="d-block d-sm-block d-md-block d-lg-none">
                        <div class="row mt-3 border-bottom" *ngFor="let s of scorecards; let i = index">
                            <div class="col-12 d-flex justify-content-between pb-2">
                                <span class="d-block p-2">No. {{i + 1}}.</span>

                            </div>
                            <div class="col-12">
                                <mat-form-field class="full-width w-100" appearance="outline">
                                    <mat-label>Challenge Name</mat-label>
                                    <input matInput
                                           [(ngModel)]="s.challengeName" [readonly]="true"
                                           [ngModelOptions]="{standalone: true}"
                                           placeholder="Challenge Name">
                                </mat-form-field>
                            </div>
                            <div class="col-12">
                                <mat-form-field class="full-width w-100" appearance="outline">
                                    <mat-label>Accuracy (%)</mat-label>
                                    <input class="text-end"
                                           type="text"
                                           mask="separator" thousandSeparator="," decimalMarker="."
                                           matInput
                                           [(ngModel)]="s.accuracy" [readonly]="true"
                                           [ngModelOptions]="{standalone: true}"
                                           placeholder="Accuracy (%)">
                                    <span class="p-4" matSuffix>%</span>
                                </mat-form-field>
                            </div>
                            <div class="col-12">
                                <mat-form-field class="full-width w-100" appearance="outline">
                                    <mat-label>Competency (%)</mat-label>
                                    <input class="text-end"
                                           type="text"
                                           mask="separator" thousandSeparator="," decimalMarker="."
                                           matInput
                                           [(ngModel)]="s.competency" [readonly]="true"
                                           [ngModelOptions]="{standalone: true}"
                                           placeholder="Competency (%)">
                                    <span class="p-4" matSuffix>%</span>
                                </mat-form-field>
                            </div>
                            <div class="col-12">
                                <mat-form-field class="full-width w-100" appearance="outline">
                                    <mat-label>Rank Level</mat-label>
                                    <input
                                            matInput
                                            [(ngModel)]="s.rankLevel" [readonly]="true"
                                            [ngModelOptions]="{standalone: true}"
                                            placeholder="Rank Level">
                                </mat-form-field>
                            </div>
                        </div>
                    </div>

                </mat-card-content>
            </mat-card>

            <mat-card class="mt-5 card-wrapper-bordered">
                <mat-card-content class="rounded-4" style="background: #F9F9F9">
                    <h5 class="my-3 text-black">Challenge: Wide-Match</h5>
                    <div class="table-wrapper-bordered d-none d-sm-none d-md-none d-lg-block">
                        <table *ngIf="wideMatch.length > 0" class="table table-borderless">
                        <thead>
                        <tr>
                            <th>Challenge Name</th>
                            <th>Average Accuracy (%)</th>
                            <th>Average Competency (%)</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let s of wideMatch; let i = index">
                            <td>
                                <span class="d-block p-2 text-black">{{s.challengeName}}</span>
                            </td>
                            <td>
                                <span class="d-block p-2 text-black">{{s.averageAccuracy}}</span>
                            </td>
                            <td>
                                <span class="d-block p-2 text-black">{{s.averageCompetency}}</span>
                            </td>

                        </tr>
                        </tbody>

                    </table>
                    </div>
                    <div class="d-block d-sm-block d-md-block d-lg-none">
                        <div class="row mt-3 border-bottom" *ngFor="let w of wideMatch; let i = index">
                            <div class="col-12 d-flex justify-content-between pb-2">
                                <span class="d-block p-2">No. {{i + 1}}.</span>
                            </div>
                            <div class="col-12">
                                <mat-form-field class="full-width w-100" appearance="outline">
                                    <mat-label>Challenge Name</mat-label>
                                    <input matInput
                                           [(ngModel)]="w.challengeName" [readonly]="true"
                                           [ngModelOptions]="{standalone: true}"
                                           placeholder="Challenge Name">
                                </mat-form-field>
                            </div>
                            <div class="col-12">
                                <mat-form-field class="full-width w-100" appearance="outline">
                                    <mat-label>Average Accuracy (%)</mat-label>
                                    <input class="text-end"
                                           type="text" [readonly]="true"
                                           mask="separator" thousandSeparator="," decimalMarker="."
                                           matInput
                                           [(ngModel)]="w.averageAccuracy"
                                           [ngModelOptions]="{standalone: true}"
                                           placeholder="Accuracy (%)">
                                    <span class="p-4" matSuffix>%</span>
                                </mat-form-field>
                            </div>
                            <div class="col-12">
                                <mat-form-field class="full-width w-100" appearance="outline">
                                    <mat-label>Average Competency (%)</mat-label>
                                    <input class="text-end"
                                           type="text" [readonly]="true"
                                           mask="separator" thousandSeparator="," decimalMarker="."
                                           matInput
                                           [(ngModel)]="w.averageCompetency"
                                           [ngModelOptions]="{standalone: true}"
                                           placeholder="Competency (%)">
                                    <span class="p-4" matSuffix>%</span>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
            <div class="row my-5">
                <div class="col-12">
                    <h5 class="my-3 text-black">Combine Assessment</h5>
                    <span class="text-black">{{assessment?.summary}}</span>
                </div>
            </div>
            <div class="row my-5">
                <div class="col-12 text-end">
                    <button (click)="goBack()" mat-raised-button style="background:#5B25B4; color: #fff;">
                        Back
                    </button>
                </div>
            </div>

        </form>
    </div>
</div>
